// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLayoutEffect, useState } from 'react';
import _debounce from 'lodash/debounce';

export const useGetBoundingClientRect = (
  params: {
    el?: HTMLElement | null;
    trackScroll?: boolean;
  },
  dependencies?: any[]
) => {
  const { el, trackScroll } = params;
  const [domRect, setDomRect] = useState<DOMRect>();

  useLayoutEffect(() => {
    const setSize = () => {
      const boundingClient = el?.getBoundingClientRect?.();

      if (boundingClient) {
        setDomRect(boundingClient);
      }
    };

    setSize();
    const handleSetSizeOnResize = _debounce(setSize, 200);

    window.addEventListener('resize', handleSetSizeOnResize);

    if (trackScroll) {
      window.addEventListener('scroll', setSize, true);
    }

    return () => {
      window.removeEventListener('resize', handleSetSizeOnResize);

      if (trackScroll) {
        window.removeEventListener('scroll', setSize, true);
      }
    };
  }, [el, trackScroll, ...(dependencies ?? [])]);

  return {
    domRect,
  };
};
